import React from "react"
import tw from "twin.macro"
import styled from "@emotion/styled"
import Container from "./Container"

const StyledPageHeading = styled.div`
  ${tw`pt-12`}
  h1, h2 {
    ${tw`text-2xl font-bold font-display uppercase leading-normal`}
  }
  ${(props) => props.alignText === "center" && tw`text-center`}
  ${(props) => props.contrastText && tw`text-white`}
  ${(props) => !props.contrastText && tw`text-blue`}
`
const PageHeading = ({ heading, headingLevel, sectionTitle, ...other }) => {
  return (
    <StyledPageHeading alignText="center" {...other}>
      <Container width="sm">
        {sectionTitle}
        {
          {
            "1": <h1>{heading}</h1>,
            "2": <h2>{heading}</h2>,
          }[headingLevel || "1"]
        }
      </Container>
    </StyledPageHeading>
  )
}

export default PageHeading
